export { PaypalIcon } from './paypal'
